export default "__VITE_ASSET__DPHrSymV__"